// business http service

import { api } from './api.config.js'

import request from '@/utils/request'

export default {
  qrcode: {
    createInvoice (data) {
      return request({
        url: api.qrcode.createInvoice,
        method: 'post',
        data
      })
    },
    invoice (data) {
      return request({
        url: api.qrcode.invoice,
        method: 'post',
        data
      })
    },
    getOrderInfo (data) {
      return request({
        url: api.qrcode.getOrderInfo,
        method: 'get',
        data
      })
    },
    getSmartTitle (data) {
      return request({
        url: api.qrcode.getSmartTitle,
        method: 'get',
        data
      })
    },
    getInvoiceBySettlementId (data) {
      return request({
        url: api.qrcode.getInvoiceBySettlementId,
        method: 'get',
        data
      })
    },
    getSelementIdById (data) {
      return request({
        url: api.qrcode.getSelementIdById,
        method: 'get',
        data
      })
    },
    addWaitTitle (data) {
      return request({
        url: api.qrcode.addWaitTitle,
        method: 'post',
        data
      })
    }
  }
}
